import { useState, Dispatch, SetStateAction } from 'react';
import { INT_DATATYPE, STRING_DATATYPE, TIME_DATATYPE } from '../../../../../../../../../constants/datatypes';
import { Filter, Comparator, AdvancedOptions, DefaultAdvancedOptions } from '../../../../../../../../../constants/types';
import { INT_COMPARATORS, STRING_COMPARATORS } from '../../../../../../../../../constants/modifiers';
import FilterOptionsSelector from './FilterOptionsSelector';
import FilterSelector from './FilterSelector';
import styles from './AttributeFilterAndComparatorSelector.module.scss';

export interface AttributeFilterSelectorProps {
  readonly filter: Filter;
  readonly filterByDate: boolean;
  readonly index: number;
  readonly modalFilters: Filter[];
  readonly setModalFilters: (modalFilters: Filter[]) => void;
  readonly showAdvancedOptions: boolean;
}

const AttributeFilterAndComparatorSelector = ({
  filter,
  filterByDate,
  index,
  modalFilters,
  setModalFilters,
  showAdvancedOptions,
}: AttributeFilterSelectorProps) => {
  const [comparator, setComparator]: [Comparator, Dispatch<SetStateAction<Comparator>>] = useState(filter.comparator);
  const [advancedOptions, setAdvancedOptions]: [AdvancedOptions, Dispatch<SetStateAction<AdvancedOptions>>] = useState(
    DefaultAdvancedOptions);
  const [filterValue, setFilterValue]: [string, Dispatch<SetStateAction<string>>] = useState(
    filter.filteredValues || '');
  const shouldShowFilterOptionsSelector = !filterByDate &&
    (filter.datatype === INT_DATATYPE || filter.datatype === STRING_DATATYPE || filter.datatype === TIME_DATATYPE);
  const showNumberComparators = filter.datatype === INT_DATATYPE || filter.datatype === TIME_DATATYPE;

  return (
    <div data-testid="filter-and-comparator-selector">
      <div className={styles.attributeParameters}>
        <div className={styles.description}>
          {filter.description}
        </div>
        {shouldShowFilterOptionsSelector ? (
          <FilterOptionsSelector
            advancedOptions={advancedOptions}
            comparator={comparator}
            filterIndex={index}
            filterValue={filterValue}
            modalFilters={modalFilters}
            selectorOptionValues={showNumberComparators ? INT_COMPARATORS : STRING_COMPARATORS}
            setAdvancedOptions={setAdvancedOptions}
            setComparator={setComparator}
            setModalFilters={setModalFilters}
            showAdvancedOptions={showAdvancedOptions}
          />
        ) : (
          <div>
            <p className={styles.anyOrNil}>
              This attribute can only be filtered on &ldquo;Any&ldquo; or &ldquo;Nil&ldquo;
            </p>
          </div>
        )}
      </div>
      <FilterSelector
        comparator={comparator}
        filter={filter}
        filterByDate={filterByDate}
        filterValue={filterValue}
        index={index}
        modalFilters={modalFilters}
        setFilterValue={setFilterValue}
        setModalFilters={setModalFilters}
      />
    </div>
  );
};

export default AttributeFilterAndComparatorSelector;
